export const BUILT_IN_MENU = [
  ["about", "/about", "nav.about"],
  ["sermons", "/sermons", "nav.sermons"],
  ["pastors", "/pastors", "nav.pastors"],
  ["gallery", "/events", "nav.gallery"],
  ["donate", "/donate", "nav.donate"],
  ["contact", "/contact", "nav.contact"],
];

// All menu entries (built-in + custom pages) sorted by the saved menu order.
export const orderedMenu = (settings, pages) => {
  const all = [
    ...BUILT_IN_MENU.map(([key, to, label]) => ({ key, to, label, builtIn: true, visible: settings?.sections?.[key] !== false })),
    ...(Array.isArray(pages) ? pages : []).map((p) => ({ key: `page:${p.id}`, to: `/p/${p.slug}`, page: p, builtIn: false, visible: p.published && p.show_in_menu })),
  ];
  const order = Array.isArray(settings?.menu_order) ? settings.menu_order : [];
  const rank = (k, i) => (order.indexOf(k) === -1 ? 1000 + i : order.indexOf(k));
  return all.map((it, i) => ({ ...it, r: rank(it.key, i) })).sort((a, b) => a.r - b.r);
};
